import React from 'react';

import { RightSidebar } from "../../../_partials/Layout";
import { SessionInterface } from "../../../../store/mine_craft/sessionsSlice";
import RowInfo from "../../../../componets/RowInfo";

const _SidebarShow = ({ session }: { session: SessionInterface | undefined }) => {
  const renderDetails = () => {
    if(!session) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={session.id} />
          <RowInfo left='#UID' right={session.uid} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
